import { Fade } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import Tooltip from 'components/common/Tooltip'
import React from 'react'

const useStyles = makeStyles(theme => ({
  noteItemActionsRoot: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    zIndex: 1,
    top: ({ placement }) => (placement === 'top' ? 2 : undefined),
    bottom: ({ placement }) => (placement === 'bottom' ? 2 : undefined),
    right: 15,
    backgroundColor: 'white',
    cursor: 'pointer',
    padding: '5px 5px 0px 5px',
    borderRadius: 8,
    boxShadow: '0px 4px 4px 0px #00000040'
  },
  action: {
    padding: '0px 8px 0px 8px'
  },
  disabled: {
    pointerEvents: 'none',
    opacity: 0.5
  }
}))

const HoveredActions = ({ actions, isOpen = false, placement = 'bottom' }) => {
  const classes = useStyles({ placement })

  return (
    <Fade in={isOpen} timeout={350}>
      <div className={classes.noteItemActionsRoot}>
        {actions.map(action => (
          <Tooltip placement="top" key={`note-action-${action.key}`} arrow value={action.tooltip}>
            <div
              className={[classes.action, action.disabled ? classes.disabled : ''].join(' ')}
              onClick={action.onClick}
            >
              {action.icon}
            </div>
          </Tooltip>
        ))}
      </div>
    </Fade>
  )
}

export default HoveredActions
